const customise = {
    DISCLAIMER: 'disclaimer',
    STOCK_ITEM: { name: 'stock' },
    VARIANT_ITEM: { name: 'variant' },
    SUMMARY_ITEM: { name: 'summary' },
    DOM_ID_PREFIX: 'customise_',
    ALL: 'all',
    NAVIGATION_ITEMS: [
        { name: 'variant' },
        { name: 'colour' },
        { name: 'interior' },
        { name: 'options' },
        { name: 'accessories' },
        { name: 'service' },
        { name: 'summary' },
    ],
    COMPLEX_NAVIGATION_ITEMS: [
        { name: 'exterior' },
        { name: 'interior' },
        { name: 'options' },
        { name: 'summary' },
    ],
    NAVIGATION_BAR_ID: 'dxpConfiguratorCustomiseNavigationBar',
    INSURANCE_BLOCK_ITEM: { name: 'insurance_block' },
    DEALER: 'Dealer',
    CONFIGURATOR_CONTROLS_LAYOUT: 'configurator_controls_layout',
    STICKY_FOOTER: 'dxp_configurator_sticky_footer',
    STOCK_SECTION: 'dxp_configurator_stock_section',
};
export default customise;
//# sourceMappingURL=customise.js.map